import {
    KEYS, get, set, remove
} from './localStorage';

const toJSON = (str) => {
    try {
        return JSON.parse(str);
    } catch (e) {
        // ignore
    }
    return undefined;
};

export const getSession = () => toJSON(get(KEYS.AUTH));


export const storeToken = token => {
    set(
        KEYS.AUTH,
        JSON.stringify({
            ...getSession(),
            token,
        }),
    );
}

export const storeSession = userData => {
    set(
        KEYS.AUTH,
        JSON.stringify({
            ...getSession(),
            ...userData,
        }),
    );
};

export const clearSession = () => {
    remove(KEYS.AUTH);
}